import type { ParagraphTimelineSteps as ParagraphTimelineStepsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphTimelineSteps.module.css";

/**
 * Layout 60 - `PARAGRAPH_TIMELINE_STEPS_LAYOUT`: pionowa lista krokow wdrozenia.
 *
 * Struktura:
 *   - Header: eyebrow (text_1) + tytul H2 (name) + lead (text)
 *   - Kolejne karty krokow (bez limitu ilosci):
 *       - Numer w kolku (CSS counter-increment - admin nie wpisuje)
 *       - Tytul kroku (h3) + opis
 *       - Opcjonalny pill po prawej z czasem (np. "1-2 tygodnie")
 */
export function ParagraphTimelineSteps({
  paragraph,
}: {
  paragraph: ParagraphTimelineStepsData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, text: lead, steps } = paragraph;
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasSteps = Array.isArray(steps) && steps.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? <p className={styles.lead}>{lead}</p> : null}
      </div>

      {hasSteps ? (
        <ol className={styles.list}>
          {steps.map((step, idx) => (
            <li key={idx} className={styles.step}>
              <span className={styles.num} aria-hidden="true" />
              <div className={styles.body}>
                {step.name ? <h3 className={styles.stepName}>{step.name}</h3> : null}
                {step.desc ? <p className={styles.stepDesc}>{step.desc}</p> : null}
              </div>
              {step.duration ? (
                <span className={styles.duration}>{step.duration}</span>
              ) : null}
            </li>
          ))}
        </ol>
      ) : null}
    </section>
  );
}
